module.exports = __webpack_public_path__ + "img/retry.c05d6337.png";